import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCallProvider, updateCallProvider } from '../apis/channel.api';

export const fetchCallProviders = createAsyncThunk(
  'callProvider/fetchCallProviders',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCallProvider();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateCallProviderStatus = createAsyncThunk(
  'callProvider/updateCallProvider',
  async ({ providerId, payload, socket }, { rejectWithValue }) => {
    try {
      const response = await updateCallProvider({ providerId, payload });
      if (response.status === 200 && socket) {
        socket.emit('CALL_PROVIDER_UPDATED', response.data);
      }
      return { providerId, data: response.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const callProviderSlice = createSlice({
  name: 'callProvider',
  initialState: {
    providers: [],
    loading: false,
    error: null,
    updating: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCallProviders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCallProviders.fulfilled, (state, action) => {
        state.loading = false;
        state.providers = action.payload.data.callProviders;
      })
      .addCase(fetchCallProviders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateCallProviderStatus.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updateCallProviderStatus.fulfilled, (state, action) => {
        state.updating = false;
        const index = state.providers.findIndex(
          (p) => p.id === action.payload.providerId
        );
        if (index !== -1) {
          state.providers[index] = {
            ...state.providers[index],
            ...action.payload.data,
          };
        }
      })
      .addCase(updateCallProviderStatus.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      });
  },
});

export default callProviderSlice.reducer;
